"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CheckResaleAvailability;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxFileName = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/CheckResaleAvailability.js",
  _templateObject,
  _templateObject2,
  _templateObject3;
function cov_17zg32hyp5() {
  var path = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/CheckResaleAvailability.js";
  var hash = "9ddc9c545c7d26d6a7fc2c60eb8527f9f560aefb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/CheckResaleAvailability.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 36
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 16
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "2": {
        start: {
          line: 23,
          column: 30
        },
        end: {
          line: 23,
          column: 59
        }
      },
      "3": {
        start: {
          line: 28,
          column: 20
        },
        end: {
          line: 34,
          column: 1
        }
      },
      "4": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 49,
          column: 4
        }
      },
      "5": {
        start: {
          line: 52,
          column: 0
        },
        end: {
          line: 61,
          column: 2
        }
      },
      "6": {
        start: {
          line: 63,
          column: 0
        },
        end: {
          line: 66,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 23,
            column: 21
          },
          end: {
            line: 23,
            column: 22
          }
        },
        loc: {
          start: {
            line: 23,
            column: 30
          },
          end: {
            line: 23,
            column: 59
          }
        },
        line: 23
      },
      "1": {
        name: "CheckResaleAvailability",
        decl: {
          start: {
            line: 36,
            column: 24
          },
          end: {
            line: 36,
            column: 47
          }
        },
        loc: {
          start: {
            line: 39,
            column: 3
          },
          end: {
            line: 50,
            column: 1
          }
        },
        line: 39
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9ddc9c545c7d26d6a7fc2c60eb8527f9f560aefb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_17zg32hyp5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_17zg32hyp5();
var AngleCircleArrowRightButton = (cov_17zg32hyp5().s[0]++, (0, _styledComponents.default)(_icon.default).attrs({
  iconName: 'angle-circle-arrow-right',
  className: 'stx-angleCircleArrowRightButton',
  size: 20
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  color: #0066ff;\n  margin-right: 0.25rem;\n"]))));
var Wrapper = (cov_17zg32hyp5().s[1]++, _styledComponents.default.div.attrs({
  role: 'button',
  tabIndex: 0
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  justify-content: ", ";\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n"])), function (props) {
  cov_17zg32hyp5().f[0]++;
  cov_17zg32hyp5().s[2]++;
  return props.justifyContentDirection;
}));
var ButtonLabel = (cov_17zg32hyp5().s[3]++, _styledComponents.default.span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  vertical-align: middle;\n  font-weight: bold;\n  color: #0066ff;\n  text-align: center;\n  text-transform: uppercase;\n"]))));
function CheckResaleAvailability(_ref) {
  var onCheckResaleAvalClickHandler = _ref.onCheckResaleAvalClickHandler,
    justifyContentDirection = _ref.justifyContentDirection;
  cov_17zg32hyp5().f[1]++;
  cov_17zg32hyp5().s[4]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    justifyContentDirection: justifyContentDirection,
    onClick: onCheckResaleAvalClickHandler,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(AngleCircleArrowRightButton, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 7
    }
  }), /*#__PURE__*/_react.default.createElement(ButtonLabel, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "button.checkResaleAvailability",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 9
    }
  })));
}
cov_17zg32hyp5().s[5]++;
CheckResaleAvailability.propTypes = {
  onCheckResaleAvalClickHandler: _propTypes.default.func,
  justifyContentDirection: _propTypes.default.oneOf(['flex-start', 'flex-end', 'center', 'initial', 'inherit'])
};
cov_17zg32hyp5().s[6]++;
CheckResaleAvailability.defaultProps = {
  onCheckResaleAvalClickHandler: null,
  justifyContentDirection: 'center'
};